<template>
  <div>
    <div v-if="testModeResolutionActive"  class="test-mode-modal">
      <div class="header">
        TEST MODE: <strong>Zakończ test</strong><br />
        Wybierz wynik testu ...<br/>
        <div class="sys__separator header-sep"/>
        <div class="close-button" @click="onCloseButtonClick">&#10754;</div>
      </div>
      <div class="content">
        <div v-for="result in scoring"
             :key="result.groupIndex"
             @click="onOptionClick(result.groupIndex)"
             class="option">
          <span class="mr-2">{{ result.groupIndex }}.</span>{{ result.groupName }}
        </div>
      </div>
    </div>
    <div v-on:dblclick="initQuizTestResolve"
         class="test-mode-button"></div>
    <button v-if="quiz.testDevMode && this.testModeResolutionWasUsed"
            @click="devTestRestartQuiz"
            class="system-button button__restart-quiz"
    >RESTART QUIZ</button>
  </div>
</template>

<script>
export default {
  name: 'TestMode',
  props: [
    'quiz',
    'questions',
    'scoring',
    'winnerIndex',
    'resolveResolution',
    'testModeResolutionActive',
    'testModeResolutionWasUsed',
  ],

  methods: {
    onOptionClick(winnerIndex) {
      this.testResolveQuiz(winnerIndex);
    },

    onCloseButtonClick() {
      this.deactivateQuizTestResolve();
    },

    // Test Mode quiz resolve
    initQuizTestResolve() {
      if (!window.Quiz.testModeEnabled) {
        return;
      }

      clearTimeout(this.testResolveTimer);
      document.addEventListener('keydown', this.onQuizTestResolveKeyboardInput);
      this.$parent.testModeResolutionActive = true;

      // if (!this.quiz.testDevMode) {
      //   this.testResolveTimer = setTimeout(this.deactivateQuizTestResolve, 5000);
      // }
    },

    deactivateQuizTestResolve() {
      document.removeEventListener('keydown', this.onQuizTestResolveKeyboardInput);
      this.$parent.testModeResolutionActive = false;
    },

    onQuizTestResolveKeyboardInput(event) {
      // eslint-disable-next-line no-restricted-globals
      if (isFinite(event.key) && Number(event.key) !== 0) {
        this.testResolveQuiz(Number(event.key));
      }
    },

    testResolveQuiz(winnerIndex) {
      const finalIndex = winnerIndex - 0;
      // console.log('testResolveQuiz', finalIndex);
      this.$parent.winnerIndex = finalIndex;
      this.$parent.numQuestion = this.questions.length;
      this.$parent.testModeResolutionActive = false;
      this.$parent.testModeResolutionWasUsed = true;
      this.$parent.resolveResolution = true;
      clearInterval(this.timer);
    },

    devTestRestartQuiz() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.test-mode-modal {
  top: 0;
  left: 0;
  margin: 3vh 3vw;
  width: 94vw;
  height: 90vh;
  position: fixed;
  background: #f0f0f0;
  z-index: 999;
  font-size: .8em;
  border-radius: 3px;
  overflow: hidden;
  font-family: Arial, sans-serif;
  background: #f0f0f0;
}

.header {
  padding: 3vh 4vw 2vh;
  color: var(--color-system-primary);
}

.content {
  padding: 1vh 2vw;
}

.option {
  padding: .1em 1em;
  cursor: pointer;
}

.option:hover {
  background: var(--color-system-primary);
  color: #ffffff;
}

.close-button {
  width: 30px;
  height: 30px;
  top: 2vh;
  right: 2vw;
  position: absolute;
  display: flex;
  font-size: 38px;
  line-height: 0;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 900px;
  color: var(--color-system-primary);
}

.close-button:hover {
  color: #8a0952;
}

.test-mode-button {
  width: 10vw;
  height: 5vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 900;
}

.button__restart-quiz {
  border: none;
  position: fixed;
  top: 2vh;
  right: 2vw;
  padding: 0.5em 2em;
  cursor: pointer;
  background: var(--color-bims-secondary);
  z-index: 1100;

  color: #FFF;
}
.button__restart-quiz:hover {
  background: var(--color-system-primary);
}

.sys__separator {
  width: 100%;
  height: 1px;
  background: var(--color-system-primary);
}
.header-sep {
  margin: 1.3em 0 0;
}
</style>
